class QhRecessoLinha {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.data = dados ? dados.data : null;
    this.diaSemana = dados ? dados.diaSemana : null;
    this.idTipoFuncao = dados ? dados.idTipoFuncao : null;
    this.funcao = dados ? dados.funcao : null;
    this.descricao = dados ? dados.descricao : null;
  }
}
export default QhRecessoLinha;
